/**
 * Shared formatters for the Beta Product Details page.
 *
 * Honors the org-wide conventions:
 *   - commas in number / currency amounts
 *   - percentages go to one decimal place
 *
 * The Product Details page header strip and every PDP tab pulls from this
 * single module so a number rendered in the header reads identically to the
 * same number rendered in a tab below.
 */

export const DASH = '-';

export const isNil = v => v === null || v === undefined || v === '';

/** $1,234,567 (rounded to whole dollars). */
export const fmtMoney = v => (isNil(v) ? DASH : `$${Math.round(v).toLocaleString('en-US')}`);

/** 12.3% — one decimal. */
export const fmtPct = v => (isNil(v) ? DASH : `${Number(v).toFixed(1)}%`);

/** 1,234 — comma-separated whole number. */
export const fmtInt = v => (isNil(v) ? DASH : Math.round(v).toLocaleString('en-US'));

/** $39.95 — currency to two decimals. */
export const fmtPrice = v =>
  isNil(v)
    ? DASH
    : `$${Number(v).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

/**
 * Scores arrive either 0–1 or 0–100 depending on the source; normalize to a
 * whole-number percent so the display stays consistent.
 */
export const fmtScore = v => (isNil(v) ? DASH : `${Math.round(Number(v) <= 1 ? v * 100 : v)}%`);
